import {Box, Card, Stack, styled} from '@mui/material';

const ContentWrapper = styled(Stack)`
	flex: 1;
`;

const ContentArea = styled(Box)`
	padding: 24px 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 32px;
	}
`;

const CenteredCard = styled(Card)`
	width: 100%;
	max-width: 560px;
	margin: 0 auto;
	padding: 32px 24px;
	border-radius: 16px;
	box-shadow: none;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 40px 56px;
	}
`;

const ListCard = styled(CenteredCard)`
	max-width: 640px;
	padding: 32px 24px 24px;
`;

const ListContainer = styled(Stack)`
	margin-top: 24px;
	border: 1px solid ${({theme}) => theme.palette.other.outlineBorder};
	border-radius: 16px;
	overflow: hidden;
`;

const ListItemRow = styled(Box)`
	display: flex;
	align-items: center;
	gap: 16px;
	padding: 16px;
	border-bottom: 1px solid ${({theme}) => theme.palette.other.outlineBorder};

	&:last-of-type {
		border-bottom: none;
	}
`;

const ItemIconWrapper = styled(Box)<{$variant: 'primary' | 'error'; $hasCustomIcon?: boolean}>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: ${({$hasCustomIcon}) => ($hasCustomIcon ? '56px' : '40px')};
	height: ${({$hasCustomIcon}) => ($hasCustomIcon ? '56px' : '40px')};
	min-width: ${({$hasCustomIcon}) => ($hasCustomIcon ? '56px' : '40px')};
	border-radius: 999px;
	background-color: ${({theme, $hasCustomIcon, $variant}) =>
		$hasCustomIcon
			? 'transparent'
			: $variant === 'error'
				? theme.palette.error.light
				: theme.palette.primary.light};
`;

const ItemIconImage = styled('img')`
	display: block;
	width: 56px;
	height: 56px;
	flex: 0 0 auto;
`;

const ActionWrapper = styled(Stack)<{$isListContent?: boolean}>`
	width: 100%;
	max-width: ${({$isListContent}) => ($isListContent ? '640px' : '560px')};
	margin: 24px auto 0;

	${({theme}) => theme.breakpoints.up('sm')} {
		align-items: flex-end;
	}
`;

export {
	ActionWrapper,
	CenteredCard,
	ContentArea,
	ContentWrapper,
	ItemIconImage,
	ItemIconWrapper,
	ListCard,
	ListContainer,
	ListItemRow,
};
